import { BrokerActionsButton } from '../Components';

export const onBrokerActionsCellRender = (e, parentId) => {
    if (!parentId) {
        return null;
    } else {
        return (
            <BrokerActionsButton
                data={e.data}
                parentId={parentId}
            />
        );
    }
};
